import PropTypes from 'prop-types';
import React from 'react';
import DistanceTo from './DistanceTo';

class HotelSummary extends React.Component {
  render() {
    const { hotel } = this.props;
    return (
      <div className="row">
        <div className="col-md-12">
          <h3>{hotel.name}</h3>
          {hotel.brand && <h4>{hotel.brand.name}</h4>}
          <div className="hotel-distance">
            <p>
              {hotel.stars ? hotel.stars :<span>Not available</span>}&nbsp;
              <span className="fa fa-star" />&nbsp;&nbsp;&nbsp;
              <a
                href={hotel.website}
                title={hotel.website}
                rel="noopener noreferrer"
                target="_blank"
                style={{ marginleft: 8 }}
              >
                <span className={hotel.website ? 'fa fa-external-link' : 'hidden'} />
              </a>{hotel.website ?(<span>&nbsp;- See hotel website</span>):''}
            </p>
          </div>
          <p>
            <i className="fa fa-map-marker" />
            {hotel.address}, {hotel.locality}, {hotel.region} {hotel.postcode}
          </p>
          <DistanceTo {...this.props.distanceTo} />
          <p>
            <i className="fa fa-phone" style={{ marginRight: 8 }} />
            {hotel.tel}
          </p>
        </div>
      </div>
    );
  }
}

HotelSummary.propTypes = {
  hotel: PropTypes.object.isRequired,
  distanceTo: PropTypes.object.isRequired,
};

export default HotelSummary;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelSummary.js